export default __webpack_public_path__ + "static/media/sprakkraft.a4ad0738.webp";